export const CUSTOMER_CANCELLATION_REASON = [
  { id: '1', reason: 'Incorrect info' },
  { id: '2', reason: 'Duplicate booking' },
  { id: '3', reason: 'Change of schedule or transport mode' },
  { id: '4', reason: 'Other transporters have accepted the job' },
  { id: '99', reason: 'Other' },
];

export const TRANSPORTER_CANCELLATION_REASON = [
  { id: '1', reason: 'Drivers / Trucks unavailable' },
  { id: '2', reason: 'Scheduling issue / Clash' },
  { id: '99', reason: 'Other' },
];
